/* Stylesheet */

.entity-selector {
  display: none;

  .item {
    --padding-start: 21px;
    border-radius: 32px;
    --background: var(--ion-background-secondary);
    box-shadow: var(--ion-box-shadow);
  }
}
